// extracted by mini-css-extract-plugin
export var avatarContainer = "_71-0";
export var avatarTypingWave = "_71-i";
export var gray = "_71-f";
export var green = "_71-c";
export var icon = "_71-9";
export var image = "_71-1";
export var lg = "_71-6";
export var md = "_71-5";
export var presenceDot = "_71-b";
export var red = "_71-d";
export var sm = "_71-4";
export var status = "_71-a";
export var typingDot = "_71-h";
export var typingPill = "_71-g";
export var xl = "_71-7";
export var xs = "_71-3";
export var xxl = "_71-8";
export var xxs = "_71-2";
export var yellow = "_71-e";